import { useEffect, useState } from 'react';
import { useAssetStateData } from 'src/features/sites/hooks';
import { AssetService } from 'src/services/assets/asset.service';

type Props = {
  siteId: string;
  customerId: string;
  pumpAssetId: string;
};

export const usePumpData = ({ siteId, customerId, pumpAssetId }: Props) => {
  const [pumpAsset, setAsset] = useState<any>();

  if (!pumpAssetId) return { runMode: null };

  // take a look at this
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (!customerId || !siteId) return;
    AssetService.getAssetById({
      customerId: customerId,
      siteId: siteId,
      assetId: pumpAssetId,
    })
      .then((data) => setAsset(data))
      .catch((error) => console.error(error));
  }, [customerId, siteId, pumpAssetId]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { assetState } = useAssetStateData({ asset: pumpAsset! });

  return { runMode: assetState, asset: pumpAsset };
};
